<template>
  <div class="cartpage">
    <fixed-header :editTitle="cartData.length?(isEdit?'完成':'编辑'):''"
                  :mg-stat-custom="`cont=${isEdit?'完成':'编辑'}&direct=cntp&label=btn&addr=`" mg-stat-click title="购物车"
                  @edit="isEdit=!isEdit"></fixed-header>
    <div class="cartpage__content scroll-touch">
      <div v-for="(item, index) in cartData" v-if="cartData.length" :key="index" class="cartpage__sku">
        <div class="cartpage__sku-check" @click="changeStatus(index);hasAnyAction=true">
          <i :class="['icon',item.selected?'selected':'not_selected']"></i>
        </div>
        <div :mg-stat-custom="`cont=${item.goodsId}&label=goods&direct=cntp&addr=haowu_goods_detail`"
             :mg-stat-lob="`goodsdc=${goodsdc}`" class="cartpage__sku-img"
             mg-stat-click
             @click="gotoGoodsDetail(item.goodsId)">
          <img :src="item.originalImg">
        </div>
        <div class="cartpage__sku-info">
          <section v-if="isEdit" class="cartpage__sku-opt-wrap">
            <div class="cartpage__sku-opt">
              <i class="icon minus_bt" @click="subtractNum(index);hasAnyAction=true"></i>
              <div>{{ item.goodsNum }}</div>
              <i class="icon add_bt" @click="addNum(index);hasAnyAction=true"></i>
            </div>
            <div mg-stat-click mg-stat-custom="label=btn&cont=删除icon&direct=cntp&addr=" @click="confirmDelete([item])">
              <i class="icon delete"></i>
            </div>
          </section>
          <p v-else>{{ item.goodsName }}</p>
          <p>{{ item.specKeyName }}</p>
          <div class="cartpage__sku-opt-wrap">
            <div class="cartpage__sku-price">
              ￥{{ item.member_goods_price || item.goodsPrice }}
            </div>
            <div v-if="!isEdit" class="cartpage__sku-opt">
              <i class="icon minus_bt" @click.stop="subtractNum(index);hasAnyAction=true"></i>
              <div>{{ item.goodsNum }}</div>
              <i class="icon add_bt" @click.stop="addNum(index);hasAnyAction=true"></i>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!cartData.length">
        <div class="cartpage__null">
          <section>
            <div><img :src="bgImg"></div>
            <div>购物车还没有商品哦~</div>
          </section>
        </div>
        <!--        <div>-->
        <!--          <goods-demo :originPage="nowPageObj"></goods-demo>-->
        <!--        </div>-->
      </div>
    </div>
    <div v-if="cartData.length" class="cartpage__bottom">
      <div class="cartpage__bottom-left">
        <div @click="selectAllCart">
          <i :class="['icon', isSelectAll?'selected':'not_selected']"></i>
          <span>全选</span>
        </div>
        <div v-if="!isEdit">
          <p>合计￥{{ totalCartInfo.total_fee }}</p>
        </div>
      </div>
      <div :class="[!isEdit?'cartpage__bottom-right':'cartpage__bottom-right--del']"
           :mg-stat-custom="`label=btn&cont=${!isEdit?('去结算' +'&direct=web&addr='):('删除商品' +'&direct=cntp&addr=')}`"
           :mg-stat-lob="`goods_id=${goodsids}&orderdc=${orderdc}`"
           mg-stat-click
           @click="submitForm">
        {{ !isEdit ? '去结算' : '删除商品' }}
      </div>
    </div>
    <nav-button></nav-button>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import FixedHeader from 'components/common/FixedHeader';
import NavButton from 'components/common/NavButton';
// import GoodsDemo from 'components/common/GoodsDemo';
import bgImg from 'assets/img/paidfail.png';
import { guid, hideMessageBox } from 'utils';
import { judgeLogin } from 'utils/user';
// import * as orderApis from 'apis/order';
import {
  beforeRouteChange,
  getGoodsSizeNum,
  initCloseUpload,
  uploadAccessData,
  uploadCloseData,
  uploadDeleteCart,
} from 'utils/uploadData';
import DataStorage from 'utils/dataStore';
import MgStat from 'MgStat';

export default {
  components: {
    FixedHeader,
    // GoodsDemo,
    NavButton,
  },
  data() {
    return {
      bgImg,
      isEdit: false,
      isSelectAll: false,
      hasAnyAction: false, // 是否有操作
      nowPageObj: this,
      hasRouteChange: false,
      goodsids: '',
      goodsdc: this.guid(),
      orderdc: this.guid(),
    };
  },
  watch: {
    cartData: {
      handler(val) {
        if (val.length) {
          this.isSelectAll = val.every(f => f.selected === 1);
          this.fetchTotalPrice();
        } else {
          this.isSelectAll = false;
        }
        const selectedArr = val.filter(f => f.selected);
        if (selectedArr.length) {
          this.goodsids = selectedArr.map(f => f.goodsId).toString();
        }
      },
      immediate: true,
      deep: true,
    },
    hasAnyAction: {
      handler(val) {
        DataStorage.setPageVisitiLog(val);
      },
      immediate: true,
    },
    isEdit: {
      handler(val) {
        this.hasAnyAction = val;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('goods', ['cartData', 'totalCartInfo']),
  },
  async created() {
    this.clearNoteData();
    uploadAccessData();
    // await this.fetchCartData();
  },
  mounted() {
    initCloseUpload();
  },
  methods: {
    guid,
    judgeLogin,
    ...mapMutations('pay', ['clearNoteData']),
    ...mapActions('goods', ['fetchCartData', 'fetchTotalPrice', 'subtractNum', 'addNum', 'changeStatus', 'fetchDeleteCart', 'selectAll', 'selectNone']),
    confirmDelete(items) {
      const ids = items.map(f => f.id);
      const goods_id = items.map(f => f.goodsId).toString();
      MgStat.send('cv', {
        goods_id,
      }, {
        mod: 'c_hwcartdetpop',
      });
      this.$message.confirm('确认删除?').then(() => {
        this.fetchDeleteCart(ids);
        uploadDeleteCart(getGoodsSizeNum(items));
        MgStat.send('click', {
          goods_id,
        }, {
          mod: 'c_hwcartdetpop',
          cont: '确定',
          direct: 'cntp',
          label: 'btn',
          cntp: 'haowu_cart',
        });
      }, () => {
        MgStat.send('click', {
          goods_id,
        }, {
          mod: 'c_hwcartdetpop',
          cont: '取消',
          direct: 'cntp',
          label: 'btn',
          cntp: 'haowu_cart',
        });
      });
    },
    gotoGoodsDetail(id) {
      if (this.isEdit) {
        return;
      }
      beforeRouteChange({ path: '/goods/detail', query: { id, showBack: 1, goodsdc: this.goodsdc } }, this);
    },
    selectAllCart() {
      this.hasAnyAction = true;
      this.isSelectAll = !this.isSelectAll;
      if (!this.cartData.length) {
        return;
      }
      if (this.isSelectAll) {
        this.selectAll();
      } else {
        this.selectNone();
      }
    },
    async submitForm() {
      const temp_orderdc = this.orderdc;
      this.orderdc = this.guid(); // 每次提交都会改变dc
      this.hasAnyAction = true;
      const { isEdit, cartData } = this;
      const selectedArr = cartData.filter(f => f.selected);
      if (!selectedArr.length) {
        this.$toast('您还没有选中商品哦');
        return;
      }
      if (isEdit) {
        this.confirmDelete(selectedArr);
      } else {
        try {
          /* 先判断登录 */
          this.judgeLogin(async () => {
            // await orderApis.getOrderSettleInfo(); /* 判断有没有库存 有就去支付页面 */
            sessionStorage.setItem('fromCart', 1);
            beforeRouteChange({ path: '/pay', query: { orderdc: temp_orderdc } }, this);
          });
        } catch (error) {
          this.$toast(`${error.message}`);
        }
      }
    },
  },
  beforeDestroy() {
    hideMessageBox();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasRouteChange) {
      uploadCloseData();
    }
    next();
  },
};
</script>

<style lang="scss">
.cartpage {
  height: 100%;
  box-sizing: border-box;

  &__content {
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 210px;
  }

  &__null {
    height: 290px;
    box-sizing: border-box;
    padding: 27px;
    margin-bottom: 30px;
    background: #fff;

    section {
      text-align: center;
      font-size: 26px;
      color: #000000;

      img {
        width: 226px;
        height: 152px;
      }

      div:last-child {
        margin-top: 30px;
      }
    }
  }

  &__sku {
    margin: 20px 30px 0 30px;
    box-sizing: border-box;
    min-height: 290px;
    background: #fff;
    border-radius: 20px;
    display: flex;
    padding: 47px 35px 38px 24px;
  }

  &__sku-check {
    width: 34px;
    flex-shrink: 0;
    margin-right: 14px;
    height: 170px;
    display: flex;
    align-items: center;
  }

  &__sku-img {
    width: 170px;
    flex-shrink: 0;
    height: 170px;
    margin-right: 30px;

    img {
      height: 100%;
      max-width: 100%;
    }
  }

  &__sku-info {
    flex: 1;

    section {
      margin-top: 20px;
      line-height: 0;
    }

    p,
    section {
      margin-bottom: 22px;
    }

    p:nth-child(1) {
      font-size: 26px;
      color: #000000;
    }

    p:nth-child(2) {
      font-size: 26px;
      color: #4a4a4a;
    }
  }

  &__sku-opt-wrap {
    display: flex;
    justify-content: space-between;
  }

  &__sku-price {
    font-size: 32px;
    color: #ff4c00;
    flex: 1;
  }

  &__sku-opt {
    width: 133px;
    display: flex;
    align-items: center;
    font-size: 28px;
    height: 38px;

    div {
      text-align: center;
      width: 57px;
      color: #000000;
    }
  }

  &__bottom {
    position: fixed;
    bottom: 100px;
    // bottom: 0px;
    left: 0;
    right: 0;
    display: flex;
    border-bottom: 1px solid #D3D3D3; /*no*/
    border-bottom: none;

    &-left,
    &-right,
    &-right--del {
      height: 98px;
      line-height: 98px;
    }

    &-left {
      flex: 1;
      display: flex;
      justify-content: space-between;
      background: #fff;
      align-items: center;

      div:first-child {
        min-width: 156px;
        box-sizing: border-box;
        padding: 0 30px;
        font-size: 28px;
        color: #000000;
        display: flex;
        align-items: center;

        span {
          margin-left: 20px;
        }
      }

      div:last-child {
        padding: 14px 18px;

        p:first-child {
          font-size: 30px;
          color: #ff4c00;
        }
      }
    }

    &-right,
    &-right--del {
      background: #ff5f00;
      width: 200px;
      text-align: center;
      font-size: 30px;
      color: #ffffff;
    }

    &-right--del {
      width: 278px;
    }
  }
}
</style>
